<div class="d-flex w-100 h-100 justify-content-center">
  <div class="d-flex flex-column my-xxl-5">
    <p-progressSpinner class="mx-auto"></p-progressSpinner>
    <p>Installing Shopify App...</p>
  </div>
</div>
